import React from 'react';
import { Heading, Box, TextField, Label, SelectList, RadioButton, Text, Switch, TextArea, Button, Badge, Avatar } from 'gestalt';
import { Link } from 'react-router-dom';
import aboutmage from '../../assets/aboutmage.png' 
import axios from 'axios'
import '../../App.css'

class Settings extends React.Component {
    render() {
        return (
            <Box padding={2}>
                <Box>
                    <Heading color='orange' size='md'>Settings</Heading>
                    <Box column={12} mdPadding={20}>
                        <Box column={4}><Link className='navLink' to='/settings/profile/'>Profile</Link></Box>
                        <Box column={4}><Link className='navLink' to='/settings/appearance/'>Appearance</Link></Box>
                        <Box column={4}><a className='navLink' href='tel:-+2348035336810'>Help</a></Box>
                        <Box column={4}><Link className='navLink' to='/about'>About</Link></Box>
                        <Box column={4}><Link className='navLink' onClick={()=>{document.cookie = "dp= ; expires = Thu, 01 Jan 1970 00:00:00 GMT"; document.cookie = "token= ; expires = Thu, 01 Jan 1970 00:00:00 GMT"; setTimeout(()=>window.location.replace('/'), 2000)}}>Log Out</Link></Box>
                    </Box>
                </Box>
            </Box>
        )
    }
}

class NavMore extends React.Component {
    render() {
        return (
            <Box padding={2}>
                <Box>
                    <Heading color='orange' size='md'>More</Heading>
                    <Box column={12} mdPadding={20}>
                        <Box column={4}><Link className='navLink' to='/profile'>Your Profile</Link></Box>
                        {/* <Box column={4}><Link className='navLink' to='/notifications'>Notifications</Link></Box> */}
                        <Box column={4}><Link className='navLink' to='/collections'>Starred Posts</Link></Box>
                        <Box column={4}><Link className='navLink' to='/settings'>Settings</Link></Box> </Box>
                </Box>
            </Box>
        )
    }
}

class Notifications extends React.Component {
    state = {
        notificationCount: 0,
        notifications: []
    }
    componentDidMount(){
        let axiosConfig = {
            headers: {
                'Authorization': this.state.token,
                'Content-Type': 'application/json',
            }
        }

        axios.get('https://baeges.herokuapp.com/api/notification/', axiosConfig)
        .then(res => {
            this.setState({
                notificationCount: res.data.count
            })
            this.setState({
                notifications: res.data.results
            })
        })
        .catch(err => {
            console.log(err.response)
        })
    }
    render() {
        return (
            <Box padding={2}>
                <Box>
                    <Heading color='orange' size='md'>{this.state.notificationCount} Notifications</Heading>
                    {this.state.notifications.map(datum => 
                    <Link to={window.location.origin+'/'+datum.link}><Box column={12} padding={3} color='watermelon'>
                        <b>{datum.message}</b><br></br>
                        <small>{datum.timestamp}</small>
                    </Box></Link>)}
                </Box>
            </Box>
        )
    }
}

class SettingAppearance extends React.Component {
    constructor(props) {
        super(props);
        this.state = { switched: this.darkValue(localStorage.getItem('dark')) };
        this.handleChange = this._handleChange.bind(this);
    }
    _handleChange() {
        this.setState({ switched: !this.state.switched });
        localStorage.setItem('dark', !this.state.switched);
        window.location.reload()
    }
    darkValue(val){
        return val === 'true'
    }
    render() {
        return (
               <Box display="flex" direction="row" alignItems="center">
                <Box paddingX={2} flex="grow">
                    <Label htmlFor="Dark">
                        <Text color='gray'>Dark mode</Text>
                    </Label>
                </Box>
                <Switch
                    onChange={this.handleChange}
                    id="Dark"
                    switched={this.state.switched}
                />
                
            </Box>
        );
    }
}


class About extends React.Component {
    render() {
        const imgStyle = {
            width: '250px',
            height: '250px',
            'border-radius': '50%'
          };
        return (
            <Box column={12}>
                <Box padding={2} lgPaddingY={6} mdPaddingY={6}>
                    <img style={imgStyle} src={aboutmage}></img>
                    <h1>Button<Badge text='beta' position='top'/>,<br></br><Text color='eggplant'>Made in 2020</Text></h1>

                    <h3>To make the internet more awesome and interactive. Everyone is welcome 
                        to join the experience.<br></br>
                        There are no geniuses here, we beleive many minds are better than one.
                    </h3>
                    <Button text='Invite Friends' color='blue' inline></Button>
                    <Button text='Donate' textColor='blue' onClick={window.location.replace('tel:-08035336810')} inline color='transparent'></Button>
                </Box>
            </Box>
        );
    }
}

class SettingProfile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
             username: '',
             name: '',
             bio: '',
             country: '',
             status: '',
             usernameError: '',
             token: this.getCookie('token'),
             id: '',
             user: '',
            };
    }

    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';')
        for(var i=0; i < ca.length; i++){
          var c = ca[i];
          while (c.charAt(0) == ' '){
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0){
            return c.substring(name.length, c.length);
          }
        }
        return "";
      }
    
    applyChanges(change=this.state){
        let axiosConfig = {
            headers: {
                'Authorization': change.token,
                'Content-Type': 'application/json; charset=UTF-8',
            }
        }

        this.setState({status: 'working on it...'})
            axios.put('https://baeges.herokuapp.com/api/profile/'+this.state.id+'/', 
            {
                username: this.state.username,
                name: this.state.name,
                description: this.state.bio,
                country: this.state.country,
                image: this.getCookie('dp'),
                user: this.state.user,
            }
            , axiosConfig)
        .then(res => {
            this.setState({
                country: res.data.country
            });
            this.setState({
                username: res.data.username
            });
            this.setState({
                name: res.data.name
            });
            this.setState({
                bio: res.data.description
            });
            this.setState({
                status: ''
            });
            console.log(res.data)
            alert('success')
        })
        .catch(err => {
            console.log(err.response)
        })
    }

    componentDidMount(){
        let axiosConfig = {
            headers: {
                'Authorization': this.state.token,
                'Content-Type': 'application/json',
            }
        }

        axios.get('https://baeges.herokuapp.com/api/profile/', axiosConfig)
        .then(res => {
            this.setState({
                country: res.data[0].country
            });
            this.setState({
                username: res.data[0].username
            });
            this.setState({
                name: res.data[0].name
            });
            this.setState({
                bio: res.data[0].description
            });
            this.setState({
                id: res.data[0].id
            });
            this.setState({
                user: res.data[0].user
            });
            console.log(res.data)
            console.log(this.state.id)
        })
    }

    render() {
        const imgStyle = {
            width: '50px',
            height: '50px',
            'border-radius': '50%'
          };
                return (
            <Box padding={2}>
                <Heading color='orange' size='md'>Edit Profile</Heading>
                <Box column={12} mdPadding={20}>
                    <Box column={12} padding={2}>
                        <Label>
                            <Text color='gray'>Your Profile Image</Text>
                        </Label>
                        <img src={this.getCookie('dp')} style={imgStyle}></img>
                    </Box>
                    <Box column={12} padding={2}>
                        <Label>
                            <Text color='gray'>Your Username</Text>
                        </Label>
                        <TextField helperText='something cool and unique'
                         value={this.state.username}
                         onChange={({value})=>this.setState({username: value})} 
                         errorMessage={!this.state.username ? "Your username" : this.state.usernameError}
                         />
                    </Box>
                    <Box column={12} padding={2}>
                        <Label>
                            <Text color='gray'>Your Name(The name your Friends can find You with)</Text>
                        </Label>
                        <TextField placeholder='Name' onChange={({value})=>this.setState({name: value})} 
                            value={this.state.name}
                            errorMessage={!this.state.name ? "Your name" : null}
                        />
                    </Box>
                    <Box column={12} padding={2}>
                        <Label>
                            <Text color='gray'>Your Bio (Optional)</Text>
                        </Label>
                        <TextArea value={this.state.bio} placeholder='Bio' onChange={({value})=>this.setState({bio: value})}
                        />
                    </Box>
                    <Box column={12} padding={2}>
                        <Label>
                            <Text color='gray'>Country</Text>
                        </Label>
                        <SelectList options={[
                            {
                                label: 'Nigeria',
                                value: 'Nigeria'
                            },
                            {
                                label: 'Algeria',
                                value: 'Algeria'
                            },
                            {
                                label: 'Australia',
                                value: 'Australia'
                            },
                            {
                                label: 'Brazil',
                                value: 'Brazil'
                            },
                            {
                                label: 'Ghana',
                                value: 'Ghana'
                            },
                            {
                                label: 'India',
                                value: 'India'
                            },
                            {
                                label: 'Italy',
                                value: 'Italy'
                            },
                            {
                                label: 'Netherlands',
                                value: 'Netherlands'
                            },
                            {
                                label: 'South Africa',
                                value: 'South Africa'
                            },
                            {
                                label: 'United States',
                                value: 'Unites States'
                            },
                            {
                                label: 'Vietnam',
                                value: 'Vietnam'
                            },
                        ]}
                        value={this.state.country}
                        onChange={({value})=>this.setState({country: value})}
                        />
                    </Box>
                    <Box column={12} padding={2}>
                        <Button onClick={()=>this.applyChanges()} text='Apply' color='blue' inline />
                        {this.state.status && <Button text={this.state.status} color='transparent' textColor='blue' inline />}
                    </Box>
                </Box>
            </Box>
        )
    }
}

export default Settings;
export { SettingAppearance, SettingProfile, About, NavMore }